const applyPatchesForLocationChangeEvent = () => {
    if (!window.egovSolutionsLocationChangePatchedApplied) {
        history.pushState = (original => function pushState() {
            const ret = original.apply(this, arguments);
            window.dispatchEvent(new Event('pushstate'));
            window.dispatchEvent(new Event('locationchange'));
            return ret;
        })(history.pushState);
        history.replaceState = (original => function replaceState() {
            const ret = original.apply(this, arguments);
            window.dispatchEvent(new Event('replacestate'));
            window.dispatchEvent(new Event('locationchange'));
            return ret;
        })(history.replaceState);
        window.addEventListener('popstate', () => {
            window.dispatchEvent(new Event('locationchange'));
        });
        window.egovSolutionsLocationChangePatchedApplied = true;
    }
};

/*
 * Public API Surface of locationchange-event
 */

/**
 * Generated bundle index. Do not edit.
 */

export { applyPatchesForLocationChangeEvent };

